import styled, { keyframes } from 'styled-components';
import { Tab } from 'react-bootstrap';

export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const PageContainer = styled.div`
  animation: ${fadeIn} 0.6s ease-out;
`;

export const FormSection = styled.div`
  display: flex;
  width: 723px;
  flex-direction: row;
  gap: 30px;
`;
export const TabContainer = styled.div`
  margin-top: 20px;
`;

export const Title = styled.p`
  font-weight: bold;
  margin-top: 20px;
`;

export const StyledTab = styled(Tab)`
  &.nav-link {
    color: #000;
  }
`;

export const NumberInput = styled.input`
  width: 80px;
`;
